import { Space } from 'antd';
import {
    Route,
    Routes,
} from 'react-router-dom';
import IMAGES from '../../const/images';
import { Footer } from '../../components/Onboarding/Footer';
import { Header } from '../../components/Onboarding/Header';
import { CreateWorkspace } from '../../components/Onboarding/CreateWorkspace';
import { AboutYouScreen } from './about-you.screen';

const OnBoardingScreen = () => (
    <div
        style={{ backgroundImage: `url(${IMAGES.login.spirals})` }}
        className="public-layout"
    >
        <div className="public-layout__container">
            <div className="public-layout__container--form">
                <Space direction="vertical" size={40}>
                    <Header />
                    <Routes>
                        <Route path="create-workspace" element={<CreateWorkspace />} />
                    </Routes>
                    <Footer />
                </Space>
            </div>
        </div>
    </div>
);

export { OnBoardingScreen };
